import useGetMyAvailableTags from '@/api/queries/me/useGetMyAvailableTags';
import { Field } from '@payaca/ambrosia';

import TagSelectCombobox from '@payaca/components/tagSelectCombobox/TagSelectCombobox';
import ValidatedFieldWrapper from '@payaca/components/validatedFieldWrapper/ValidatedFieldWrapper';
import { TagActionConfig } from '@payaca/types/automationTypes';
import { FieldValidationResult } from '@payaca/types/fieldValidationTypes';
import { FC } from 'react';

export type TProps = {
  config: TagActionConfig;
  onChange: (changeValue: { [key: string]: any }) => void;
  validationState?: Record<string, FieldValidationResult>;
  touchedState?: Record<string, boolean>;
  onTouch?: (fieldName: string) => void;
  showFieldValidationMessagesUnconditionally?: boolean;
};

const TagAutomationActionConfigFieldset: FC<TProps> = (props) => {
  const {
    config,
    validationState,
    onTouch,
    touchedState,
    onChange,
    showFieldValidationMessagesUnconditionally,
  } = props;

  const { data: availableTags } = useGetMyAvailableTags();

  return (
    <ValidatedFieldWrapper
      validationResult={validationState?.tagIds}
      isTouched={
        !!touchedState?.tagIds || showFieldValidationMessagesUnconditionally
      }
    >
      <Field.Legacy className="mb-4">
        <Field.Label>Tags</Field.Label>
        <TagSelectCombobox
          multiple={true}
          availableTags={
            availableTags?.map((i) => ({
              id: +i.id,
              tagText: i.name,
              tagColour: i.colour || '',
            })) || []
          }
          value={config.tagIds}
          onChange={(value) => {
            onTouch?.('tagIds');
            onChange({ tagIds: value });
          }}
        />
      </Field.Legacy>
    </ValidatedFieldWrapper>
  );
};

export default TagAutomationActionConfigFieldset;
